import {Injectable} from '@angular/core';
import {CanActivate, CanActivateChild, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Store} from '@ngrx/store';
import {selectAppAndUserLoadedSettings} from '../../journal/src/_selectors/journal.selectors';
import {catchError, mapTo, skipWhile} from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class SettingsInStoreGuard implements CanActivateChild, CanActivate {
	constructor(private store: Store) {}
	private check() {
		return this.store.select(selectAppAndUserLoadedSettings).pipe(
			skipWhile(r => !r)
		);
	}
	canActivateChild(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.check().pipe(
			mapTo(true),
			catchError(() => of(false))
		);
	}

	canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.check().pipe(
			mapTo(true),
			catchError(() => of(false))
		);
	}
}
